import React from 'react';

const WhyChooseSection = () => {
  return (
    <div className="container my-5" id="about">
      <section>
        <h3 className="text-center mb-5" style={{ fontFamily: 'asap condensed' }}>
          Why Choose Bitejoy?
        </h3>

        <div className="row">
          <div className="col-lg-6 mb-4 mb-lg-0 pb-2 pb-lg-0 pb-xl-2">
            <img
              src="/images/Bitejoy/bitejoyb2.jpg"
              className="img-fluid"
              alt="Sample image"
            />
          </div>
          <div className="col-lg-6">
            <h4 className="mb-4" style={{ fontWeight: 'bold' }}>
              Premium Dubai Dates & Handpicked Dry Fruits
            </h4>
            <p className="lead mb-4 pb-1">* No added sugar</p>
            <p className="lead mb-4 pb-1">* High protein & energy-rich</p>
            <p className="lead mb-4 pb-1">* Handcrafted in small batches</p>
            <p className="lead mb-4 pb-1">* Suitable for all age groups</p>
            <p className="lead mb-4 pb-1">
              * Available online & offline with PAN India delivery
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default WhyChooseSection;
